import {
  ItemsTechno,
  charItems,
  patItems,
  primItems,
  boulItems,
  cuisineItems,
} from "./welcomeInterface";

interface Job {
  label: string;
  labelUpper: string;
  key: string;
  href: string;
  itemsWelcome: Array<ItemsTechno | ItemsTechno[]>;
  polesTutorials: Pole[];
  polesTechnologie: Pole[];
  badges: Badge[];
}

export interface Pole {
  name: string;
  number: number;
}

interface Badge {
  name: string;
  picture: string;
}

const boul: Job = {
  href: "boul",
  itemsWelcome: boulItems,
  key: "boul",
  label: "boulangerie",
  labelUpper: "Boulangerie",
  polesTutorials: [{ name: "Tutoriels vidéo", number: 1 }],
  polesTechnologie: [{ name: "Savoirs associés", number: 1 }],
  badges: [
    "Apprenti",
    "Aide-boulanger",
    "Geindre",
    "Boulanger",
    "Brigadier",
    "Traiteur",
    "Tourier",
    "Chef exècutif",
    "Gérant",
    "Chef d'entreprise",
  ].map((name, index) => {
    return {
      name,
      picture:
        "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/badge/pat/" +
        (index + 1) +
        ".png",
    };
  }),
};

const pat: Job = {
  href: "pat",
  itemsWelcome: patItems,
  key: "pat",
  label: "pâtisserie",
  labelUpper: "Pâtisserie",
  polesTutorials: [
    { name: "Pole 1", number: 1 },
    { name: "Pole 2", number: 2 },
  ],
  polesTechnologie: [
    { name: "Pole 1", number: 1 },
    { name: "Pole 2", number: 2 },
  ],
  badges: [
    "Apprenti",
    "Aide-pâtissier/commis",
    "Pâtissier",
    "Tourier",
    "Fournier",
    "Entremétier",
    "Glacier",
    "Confiseur",
    "Chocolatier",
    "Chef exécutif",
  ].map((name, index) => {
    return {
      name,
      picture:
        "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/badge/pat/" +
        (index + 1) +
        ".png",
    };
  }),
};

const char: Job = {
  badges: [],
  href: "char",
  itemsWelcome: charItems,
  key: "char",
  label: "charcuterie",
  labelUpper: "Charcuterie",
  polesTechnologie: [],
  polesTutorials: [],
};

const prim: Job = {
  badges: [],
  href: "prim",
  itemsWelcome: primItems,
  key: "prim",
  label: "primeur",
  labelUpper: "Primeur",
  polesTechnologie: [],
  polesTutorials: [],
};

const cuisine: Job = {
  badges: [],
  href: "cuis",
  itemsWelcome: cuisineItems,
  key: "cuis",
  label: "cuisine",
  labelUpper: "Cuisine",
  polesTechnologie: [],
  polesTutorials: [],
};

export const jobsArray: Job[] = [boul, pat, char, prim, cuisine];

export const jobsMap: Map<string, Job> = transferToMap();

function transferToMap(): any {
  // Convertit le tableau en une Map
  let mapsJobs = new Map(
    jobsArray.map((job) => {
      // Si itemsWelcome existe et est un tableau, on filtre les éléments
      if (
        Array.isArray(job.itemsWelcome) &&
        process.env.REACT_APP_NAME === "DELICEO"
      ) {
        job.itemsWelcome = job.itemsWelcome.filter(
          (item: any) => item.title !== "Travaux pratiques et dirigés"
        );
      }
      // Crée un nouveau job sans toucher aux autres propriétés
      const jobWithoutItems = { ...job };
      return [job.key, jobWithoutItems];
    })
  );
  return mapsJobs;
}

export const getCurrentTechnoOrDisconnect = (): string => {
  const techno = getCurrentTechno();
  if (techno.length <= 0) {
    localStorage.clear();
    window.location.reload();
    return "";
  }
  return techno;
};

export const getCurrentTechno = (): string => {
  const currentTechno = localStorage.getItem("techno");
  if (currentTechno === null || currentTechno === undefined) {
    return "";
  }
  return currentTechno;
};
